import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-youtube-channel',
  templateUrl: './youtube-channel.component.html',
  styleUrls: ['./youtube-channel.component.css']
})
export class YoutubeChannelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
